import React from "react";
import signUpImg from "../../images/newsletter.png";
import AppStore from "../../images/app-icon-02.webp";
import Googleplay from "../../images/app-icon-01.webp";
import payment from "../../images/payment.png";
// import css file
import { FaPinterest } from "react-icons/fa";
// import { FaBeer } from 'react-icons/fa';
import { BsInstagram, BsYoutube, BsFacebook } from "react-icons/bs";
import { AiOutlineTwitter } from "react-icons/ai";
import "./Footer.css";
import { Link } from "react-router-dom";
const Footer = () => {
  const slideUp = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div
        className="footer  "
        style={{ backgroundColor: "#232f3e", padding: "10px 0px" }}
      >
        <footer
          style={{
            borderBottom: "1px solid rgba(255,255,255,.1)",
            padding: "40px 0px",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <h3 className="text-white mx-3 text-bold">
                  <img src={signUpImg} alt="footer_img"></img>&nbsp;Sign Up For
                  Newsletter
                </h3>
              </div>
              <div className="col-lg-6">
                <div className="input-group ">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Email.."
                    aria-label="Your Email.."
                    aria-describedby="basic-addon2"
                    style={{ outline: "none" }}
                  />
                  <span
                    className="input-group-text "
                    id="basic-addon2"
                    style={{ backgroundColor: "#FEBD69", cursor: "pointer" }}
                  >
                    SUBSCRIBE
                  </span>
                </div>
              </div>
            </div>
          </div>
        </footer>

        <div className="mid-footer">
          <div className="container-fluid">
            <div className="row">
              <div className="contact col-lg-3 col-md-6 col-sm-6">
                <h2>Contact us </h2>
                <ul>
                  <li>
                    <span>
                      Demo Store
                      <br></br>
                      No. 1259 Freedom, New York, 11111
                      <br></br>
                      United States
                    </span>
                  </li>
                  <li>
                    <span>+91-987654321</span>
                  </li>
                  <li>
                    <span>demo@exampledemo.com</span>
                  </li>
                </ul>
                <ul className="social_links">
                  <li>
                    <BsFacebook />
                  </li>
                  <li>
                    <AiOutlineTwitter />
                  </li>
                  <li>
                    <FaPinterest />
                  </li>
                  <li>
                    <BsInstagram />
                  </li>
                  <li>
                    <BsYoutube />
                  </li>
                </ul>
              </div>
              <div className="information  col-lg-2 col-md-6 col-sm-6">
                <h2>information</h2>
                <ul>
                  <li>Privacy policy</li>
                  <li>Refund policy</li>
                  <li>Shipping policy</li>
                  <li>Terms of service</li>
                  <li>Blogs</li>
                </ul>
              </div>
              <div className="account  col-lg-2 col-md-6 col-sm-6">
                <h2>account</h2>
                <ul>
                  <li>
                    <Link to={"/Account"} onClick={() => slideUp()}>
                      Account
                    </Link>
                  </li>
                  <li>
                    <Link to={"/About"} onClick={() => slideUp()}>
                      About us
                    </Link>
                  </li>
                  <li>
                    <Link to={"/Faqs"} onClick={() => slideUp()}>
                      Faq
                    </Link>
                  </li>
                  <li>
                    <Link to={"/Contact"} onClick={() => slideUp()}>
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link to={"/Termsandcondition"} onClick={() => slideUp()}>
                      Terms & Condition
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="quicklinks  col-lg-2 col-md-6 col-sm-6">
                <h2>quicklinks</h2>
                <ul>
                  <li>
                    <Link to={"/OurStore"}>Accessories</Link>
                  </li>
                  <li>
                    {" "}
                    <Link to={"/OurStore"} onClick={() => slideUp()}>
                      laptops
                    </Link>
                  </li>
                  <li>
                    <Link to={"/OurStore"} onClick={() => slideUp()}>
                      headphones
                    </Link>
                  </li>
                  <li>
                    <Link to={"/OurStore"} onClick={() => slideUp()}>
                      smart watches
                    </Link>
                  </li>
                  <li>
                    <Link to={"/OurStore"} onClick={() => slideUp()}>
                      tablets
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="our_app  col-lg-3 col-md-6 col-sm-6">
                <h2>our app</h2>
                <p style={{ fontSize: "13px", margin: "14px 0px" }}>
                  Download our App and get extra 15%<br></br> Discount on your
                  first Order..!
                </p>
                <span>
                  <img src={Googleplay} alt="googleplay"></img>
                </span>
                <span>
                  <img src={AppStore} alt="AppStore"></img>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* start bottom footer */}
        <div className="container-fluid">
          <div className="bottom_footer text-white flex-wrab">
            <p
              style={{ fontSize: "13px", paddingTop: "10px", display: "block" }}
            >
              {" "}
              &copy; {new Date().getFullYear()}&nbsp; Powered By Hossam Mohamed
            </p>
            <img src={payment} alt="payment_img"></img>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
